import { ProductData, Results } from "./types";

export function calculateResults(
  productData: ProductData,
  surface: number,
  thickness: number,
  product: string,
  shouldRoundThickness: boolean
): Results {
  let thicknessM = thickness / 1000;
  if (shouldRoundThickness) {
    thicknessM *= 0.99;
  }

  const rawResistance = thicknessM / productData.thermalCond;
  const thermalResistance = Math.round(rawResistance * 10) / 10;

  const insulationM3 = (surface * thickness) / 1000;
  const insulationKg = insulationM3 * productData.bulkDensity;
  const total = Math.ceil(insulationKg / (productData.kgPackage ?? 16.6));

  return {
    bulkDensity: productData.bulkDensity,
    thermalCond: productData.thermalCond.toFixed(3),
    thermalRes: thermalResistance.toFixed(2),
    insulation: insulationKg.toFixed(1),
    kgPackage: 16.6,
    product: product,
    total: total.toString(),
  };
}
